import { Component, Event, EventEmitter, h, Listen, State } from '@stencil/core';
import { Pill, FacetItem, FilterPillChangeEvent, PaginationData, FacetUpdateEvent, logDebug, Option } from '@hpfc/fc-frontend-core';

function removeTrailingNumber(str: string): string {
  const regex = /\s*\(\d+\)$/;
  return str.replace(regex, '');
}

/**
 * Show filtered search criteria from event data.
 */
@Component({
  tag: 'fccd-pill-block',
  styleUrl: 'fccd-pill-block.scss',
})
export class FccdPillBlock {
  /**
   * data keeps track of all the selected Pill Blocks
   */
  @State() data: Array<Pill> = [];

  /**
   * Dispatches this event when a Pill Block selection is made.
   */
  @Event() fccdFilterPillChangeEvent: EventEmitter<FilterPillChangeEvent>;

  /**
   * Lister to listen when a Pill Block selection is made
   * @param event
   */
  @Listen('fccdComponentEvent', { target: 'document' })
  updateHandler(event: CustomEvent<FacetUpdateEvent>) {
    logDebug('Event Test: ', event.detail);

    const facetMap = event?.detail?.facetMap;
    if (!facetMap) return;

    if (facetMap.size < 2) {
      this.data = [];
    }
    this.data = this.genPillList(facetMap, event?.detail?.facetOptionMap);
  }

  /**
   * Listener to capture a Pill Block delete event
   * @param event
   */
  @Listen('hpPillClicked', { target: 'document' })
  updatePills(event: CustomEvent<any>) {
    logDebug('Checking Delete Pill event', event);

    if (!event?.detail?.pill) return;

    const { pillId: pillIDToDelete, text: pillTextToDelete, index: pillValue } = event.detail.pill;

    //Generate the facetItem for deleting the selected Pill Block
    const facetItem: FacetItem = new FacetItem(pillIDToDelete, pillValue ? pillValue : pillTextToDelete, false);

    //Re-generate list of current Pill Blocks from the filtered Pills after deleting the Pill Block
    const filteredPills = this.data.filter(pill => pill.text !== pillTextToDelete);

    //Refresh the state of the list of Pill Blocks
    this.data = [...filteredPills];

    //Emit fccdFilterPillChangeEvent event after deleting the Pill
    this.fccdFilterPillChangeEvent.emit(new FilterPillChangeEvent(event, facetItem));
  }

  genPillList(facetMap: Map<string, FacetItem>, facetOptionMap: Map<string, Option[]>): Pill[] {
    const pills: Array<Pill> = [];
    facetMap?.forEach(facetItem => {
      if (facetItem.value instanceof PaginationData || facetItem.pillBlockDisabled) return;
      const isValidFacet = facetItem.value && 'Any' != facetItem.value;
      if (!isValidFacet) return;

      const facetOptions: Array<Option> = facetOptionMap?.get(facetItem.controlName);
      if (facetItem.value instanceof Array && facetOptionMap == null) return;

      if (facetOptions) {
        facetOptions?.forEach(optionItem => {
          if (optionItem.isSelected) {
            pills.push(new Pill(facetItem.controlName, removeTrailingNumber(optionItem.name), optionItem.value));
          }
        });
      } else {
        pills.push(new Pill(facetItem.controlName, facetItem.value));
      }
    });
    return pills;
  }

  render() {
    return (
      <div class="pill-blocks">
        <hp5-pill-block pill-array-json={JSON.stringify(this.data)} />
      </div>
    );
  }
}
